import { Link } from 'react-router-dom';
import { hotGossipItems } from '@/mocks/home';

export default function HotGossip() {
  return (
    <section className="w-full py-16 md:py-24">
      <div className="w-full px-6 md:px-10 max-w-6xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <p className="text-xs font-medium text-secondary-500 uppercase tracking-widest font-label mb-3">
            热门追踪
          </p>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950">
            最新爆料火速围观
          </h2>
        </div>

        <div className="overflow-x-auto pb-4 -mx-6 md:-mx-10 px-6 md:px-10">
          <div className="flex gap-5 min-w-max">
            {hotGossipItems.map((item) => (
              <Link
                key={item.id}
                to={`/article/${item.slug}`}
                className="group block w-[260px] md:w-[280px] flex-shrink-0 bg-background-100 rounded-xl overflow-hidden hover:bg-background-200/70 transition-colors duration-300"
              >
                <div className="relative">
                  {item.isHot && (
                    <span className="absolute top-3 left-3 z-10 px-2.5 py-1 text-[10px] font-semibold bg-primary-500 text-background-50 rounded-md font-label uppercase tracking-wider">
                      热门
                    </span>
                  )}
                  <div className="w-full overflow-hidden" style={{ aspectRatio: '3/4' as string }}>
                    <img
                      src={item.image}
                      alt={`${item.name} - ${item.title}`}
                      title={`51黑料吃瓜网 - ${item.name}${item.title}`}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                </div>
                <div className="p-4">
                  <span className="inline-block px-2 py-0.5 text-[10px] font-medium bg-secondary-100 text-secondary-700 rounded-full mb-2 font-label">
                    {item.category}
                  </span>
                  <h3 className="text-sm font-semibold text-foreground-950 mb-1 line-clamp-2 leading-snug">
                    {item.name}：{item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mb-3 line-clamp-2 leading-relaxed">
                    {item.summary}
                  </p>
                  <div className="flex items-center gap-1 text-xs text-foreground-400">
                    <i className="ri-fire-line text-accent-500"></i>
                    <span>{item.heat} 热度</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>

        <div className="flex justify-center mt-8">
          <Link
            to="/category/star-scandal"
            className="inline-flex items-center gap-2 px-6 py-2.5 text-sm font-medium text-foreground-600 hover:text-foreground-950 transition-colors duration-200 font-label"
          >
            查看全部爆料
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}